var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    width: 700,
    height: 700,
    opacity: 0.68,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "nnnoise-filter",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "linearRGB"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 0.2,
    numOctaves: 4,
    seed: 15,
    stitchTiles: "stitch",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    result: "turbulence"
  }), /*#__PURE__*/React.createElement("feSpecularLighting", {
    surfaceScale: 6,
    specularConstant: 0.7,
    specularExponent: 20,
    lightingColor: "#FFC2E2",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    in: "turbulence",
    result: "specularLighting"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    azimuth: 3,
    elevation: 115
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 700,
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 700,
    fill: "#ffc2e2",
    filter: "url(#nnnoise-filter)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.63b211f23d8cef86b23f560efec59459.svg";
export { ForwardRef as ReactComponent };